import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-x-0 top-0 z-[60] h-[3px]" }

import { onBeforeUnmount, onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollProgress',
  setup(__props) {

const progress = ref(0);

const update = () => {
  const max = document.documentElement.scrollHeight - window.innerHeight;
  progress.value = max > 0 ? window.scrollY / max : 0;
};

onMounted(() => {
  update();
  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
});
onBeforeUnmount(() => {
  window.removeEventListener("scroll", update);
  window.removeEventListener("resize", update);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "h-full origin-left bg-gradient-to-r from-copper-deep via-copper-light to-ember shadow-[0_0_12px_rgba(255,122,47,0.8)]",
      style: _normalizeStyle({ transform: `scaleX(${progress.value})` })
    }, null, 4)
  ]))
}
}

})